import { IOnboardingChecklistState } from "./onboardingChecklist.types";

export const defaultOnboardingChecklistState: IOnboardingChecklistState = {
  data: null,
  loading: false,
  error: null,
};
